import React from "react";
import { useStyles } from "./styles";

export const NewsWidgetRow = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <>
      <div className={classes.row} ref={ref}>
        {children}
      </div>
    </>
  );
};
NewsWidgetRow.muiName = "NewsWidgetRow";
NewsWidgetRow.displayName = "NewsWidgetRow";

export default NewsWidgetRow;
